import { BaseStore } from "stores/base_store";
import { runInAction, makeAutoObservable } from "mobx";
import { api_get } from "api/utils";
import { api_post } from "api/utils";
import { CursorType } from "utils/types";

export type IncomingPhoneNumberType = {
    key: string;
    uuid: string;
    identity: string;
    associated_type: string;
    associated_uuid: string;
    phone_number: string;
    extension: string;
    formatted_phone_number: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: IncomingPhoneNumberType) => void;
};

// Domain object IncomingPhoneNumber
export class IncomingPhoneNumber implements IncomingPhoneNumberType {
    key = "";
    uuid = "";
    identity = "";

    associated_type = "";
    associated_uuid = "";
    phone_number = "";
    extension = "";
    formatted_phone_number = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: IncomingPhoneNumberType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: IncomingPhoneNumberType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class IncomingPhoneNumberStore extends BaseStore<IncomingPhoneNumberType, IncomingPhoneNumber> {

    async fetchIncomingPhoneNumber(uuid: string) {
        // Autogenerated
        const response = await api_get(`/incoming-phone-number?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async getOrCreate(workKey: string, associated_type: string, associated_uuid: string) {
        // Naturally, this is a post request.
        const data = { identity: workKey, associated_type, associated_uuid };
        const response = await api_post("/incoming-phone-number/get-or-create", data);
        console.log("earlie, this: %o", this);
        if(response.ok) {
            const data = await response.json();
            console.log("IncomingPhoneNumberStore.getOrCreate response", data);
            console.log("this: %o", this);
            this.receiveUpdate(data);
            return data;
        }
        else {
            return null;
        }
    }

    async getOnly(identity: string, associated_type: string, associated_uuid: string) {
        const data = { identity, associated_type, associated_uuid };
        const response = await api_get("/incoming-phone-number/get", data);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        else {
            return null;
        }
    }


    async fetchListByAssociation(identity: string, associated_type: string, associated_uuid: string, cursor?: CursorType): Promise<IncomingPhoneNumberType[]>  {
        const url = "/incoming-phone-number/list-by-association";
        const params = {
            identity,
            associated_type,
            associated_uuid,
            cursor: cursor || ''
        };
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByAssociation(identity, associated_type, associated_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but IncomingPhoneNumberStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    modelConstructor() {
        return IncomingPhoneNumber;
    }

}
